import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../types';
import DateInput from '../InputComponents/Date';
import FrequencyInput from '../InputComponents/Frequency';
import TimeOfDay from '../InputComponents/TimeOfDay';

const TIME_OF_DAY_CLASSES = { label: 'ms-6 me-12' };

const Yearly = ({
  value,
  onChange,
  hideTimeSelection,
  disabled,
  allowedFrequencies,
  size,
}: FrequencyComponentProps) => {
  const { t } = useTranslation();
  return (
    <Stack direction="col" gapY={16}>
      <Stack alignItems="center" justifyContent="between">
        <FrequencyInput
          allowedFrequencies={allowedFrequencies}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
        <Typography
          className="mx-12"
          variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
          {t('On')}
        </Typography>
        <DateInput disabled={disabled} value={value} onChange={onChange} />
      </Stack>
      {hideTimeSelection ? null : (
        <TimeOfDay
          classes={TIME_OF_DAY_CLASSES}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
      )}
    </Stack>
  );
};

export default Yearly;
